import { FilterChipListWrapper } from '@user/components/Filters/FilterChip'
import {
  DraftLead,
  DraftLeadFilterSet,
  selectDraftLeadFilters,
  useSaveDraftLeadFilters,
  defaultFilters,
} from '@user/store/draftLeads'
import * as React from 'react'
import { useSelector } from 'react-redux'

export function DraftLeadFilterChipList() {
  const saveDraftLeadFilters = useSaveDraftLeadFilters()
  const { filterSet } = useSelector(selectDraftLeadFilters)
  return (
    <FilterChipListWrapper<DraftLead, DraftLeadFilterSet>
      applyCallback={saveDraftLeadFilters}
      clearedFilters={defaultFilters}
      filterSet={filterSet}
    />
  )
}
